import { configureStore } from "@reduxjs/toolkit";

//SLICES
import menusSlice from "./menus";
import userSlice from "./user";

const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    menus: menusSlice.reducer,
  },
});

export default store;

export type AppDispatch = typeof store.dispatch;
